<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div>
          <h1 class="title">Virtual Visit Email</h1>
        </div>

        <section
          class="section interview-question-wrap column is-full-mobile is-full-tablet is-full-desktop is-two-thirds-widescreen mt2"
        >
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <h1 class="subtitle">Virtual Visit Created</h1>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <div v-if="!editCreated">
                  <button
                    class="button is-info is-small"
                    @click="toggleEditCreated"
                  >
                    Edit
                  </button>
                </div>
                <div v-if="editCreated">
                  <button
                    :class="[
                      'button',
                      'is-primary',
                      'is-small',
                      { 'is-loading': loadingCreated }
                    ]"
                    @click="saveCreated"
                  >
                    Update
                  </button>
                  <button class="button is-small" @click="toggleEditCreated">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="question" v-if="!editCreated">
            <strong>{{ createdSubject }}</strong>
            <br />
            <pre>{{ createdBody }}</pre>
          </div>

          <div class="question" v-if="editCreated">
            <div class="field">
              <label class="label">Header</label>
              <div class="control mt-2">
                <input
                  type="text"
                  class="input"
                  v-model="createdEmailSubject"
                />
              </div>
            </div>

            <div class="field">
              <label class="label">Message</label>
              <div class="control mt-2">
                <textarea
                  class="textarea"
                  v-model="createdEmailBody"
                ></textarea>
              </div>
            </div>
          </div>
        </section>

        <section
          class="section interview-question-wrap column is-full-mobile is-full-tablet is-full-desktop is-two-thirds-widescreen mt2"
        >
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <h1 class="subtitle">Virtual Visit 1 Hour Reminder</h1>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <div v-if="!editReminder">
                  <button
                    class="button is-info is-small"
                    @click="toggleEditReminder"
                  >
                    Edit
                  </button>
                </div>
                <div v-if="editReminder">
                  <button
                    :class="[
                      'button',
                      'is-primary',
                      'is-small',
                      { 'is-loading': loadingReminder }
                    ]"
                    @click="saveReminder"
                  >
                    Update
                  </button>
                  <button class="button is-small" @click="toggleEditReminder">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="question" v-if="!editReminder">
            <strong>{{ reminderSubject }}</strong>
            <br />
            <pre>{{ reminderBody }}</pre>
          </div>

          <div class="question" v-if="editReminder">
            <div class="field">
              <label class="label">Header</label>
              <div class="control mt-2">
                <input
                  type="text"
                  class="input"
                  v-model="reminderEmailSubject"
                />
              </div>
            </div>

            <div class="field">
              <label class="label">Message</label>
              <div class="control mt-2">
                <textarea
                  class="textarea"
                  v-model="reminderEmailBody"
                ></textarea>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import _ from "lodash";
import SettingsService from "@/services/SettingsService";

export default {
  name: "settings-virtual-visit-email",

  data() {
    return {
      createdEmailSubject: "",
      createdEmailBody: "",
      editCreated: false,
      loadingCreated: false,
      reminderEmailSubject: "",
      reminderEmailBody: "",
      editReminder: false,
      loadingReminder: false
    };
  },

  computed: {
    createdSubject() {
      const subject = this.$store.getters["settings/kind"](
        "virtual_visit_email_created_subject"
      );
      let value = "";
      if (_.has(subject[0], "attributes.value")) {
        value = subject[0].attributes.value;
      }
      return value;
    },
    createdBody() {
      const subject = this.$store.getters["settings/kind"](
        "virtual_visit_email_created_body"
      );
      let value = "";
      if (_.has(subject[0], "attributes.value")) {
        value = subject[0].attributes.value;
      }
      return value;
    },
    reminderSubject() {
      const subject = this.$store.getters["settings/kind"](
        "virtual_visit_email_reminder_subject"
      );
      let value = "";
      if (_.has(subject[0], "attributes.value")) {
        value = subject[0].attributes.value;
      }
      return value;
    },
    reminderBody() {
      const subject = this.$store.getters["settings/kind"](
        "virtual_visit_email_reminder_body"
      );
      let value = "";
      if (_.has(subject[0], "attributes.value")) {
        value = subject[0].attributes.value;
      }
      return value;
    }
  },

  methods: {
    getEmails() {
      this.loading = true;
      SettingsService.getVirtualVisitEmails();
    },
    toggleEditCreated() {
      this.createdEmailSubject = this.createdSubject;
      this.createdEmailBody = this.createdBody;
      this.editCreated = !this.editCreated;
      this.loadingCreated = false;
    },
    async saveCreated() {
      this.loadingCreated = true;
      let object = this.$store.getters["settings/kind"](
        "virtual_visit_email_created_subject"
      )[0];
      await this.update(object, this.createdEmailSubject);

      object = this.$store.getters["settings/kind"](
        "virtual_visit_email_created_body"
      )[0];
      await this.update(object, this.createdEmailBody);

      this.loadingCreated = false;
      this.editCreated = false;
      this.$refs.toastr.s("The virtual visit created email has bee updated.");
    },
    async update(object, value) {
      this.loadingCreated = true;
      const data = object.attributes;
      data.id = object.id;
      data.value = value;
      return SettingsService.update(data);
    },
    toggleEditReminder() {
      this.reminderEmailSubject = this.reminderSubject;
      this.reminderEmailBody = this.reminderBody;
      this.editReminder = !this.editReminder;
      this.loadingReminder = false;
    },
    async saveReminder() {
      this.loadingReminder = true;
      let object = this.$store.getters["settings/kind"](
        "virtual_visit_email_reminder_subject"
      )[0];
      await this.update(object, this.reminderEmailSubject);

      object = this.$store.getters["settings/kind"](
        "virtual_visit_email_reminder_body"
      )[0];
      await this.update(object, this.reminderEmailBody);

      this.loadingReminder = false;
      this.editReminder = false;
      this.$refs.toastr.s("The virtual visit reminder email has bee updated.");
    }
  },

  mounted() {
    this.getEmails();
  }
};
</script>

<style lang="scss" scoped></style>
